<template>
	<div class="navigation-zone" v-if="navList && navList.length">
		<a
			class="nav-item"
			v-for="(item, idx) in navList"
			:key="idx"
			:href="mateUrl(item.linkUrl) || item.linkUrl || 'javascript:void(0)'"
			:rel="isCrossDomain(item.linkUrl) ? 'nofollow' : undefined"
			@click.prevent="gotoPage(item)"
		>
			<img :src="item.imgUrl" alt="导航图标" class="nav-icon" />
			<text class="nav-text">{{ item.title }}</text>
		</a>
	</div>
</template>

<script setup>
import { jumpTo, mateUrl } from '@/utils/mateUrl.js';

defineProps({
	navList: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['click']);

function gotoPage(item) {
	const { linkUrl } = item;
	if (linkUrl) {
		emit('click');
		jumpTo(linkUrl);
	}
}

function isCrossDomain(linkUrl) {
	if (!linkUrl) return false;
	const normalizedUrl = String(linkUrl);
	if (normalizedUrl.startsWith('/')) return false;
	return !normalizedUrl.includes('cmic.com.cn') && !normalizedUrl.includes('gyqxmall.com');
}
</script>

<style lang="scss" scoped>
.navigation-zone {
	box-sizing: border-box;
	margin: 0 8px;
	padding: 10px 8px;
	display: grid;
	grid-template-columns: repeat(4, 1fr); /* 创建3列等宽 */
	gap: 8px 20px; /* 列之间的间距 */
	border-radius: 5px;
	background-color: #fff;
	margin-bottom: 6px;

	.nav-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		text-decoration: none;
		color: inherit;
	}

	.nav-icon {
		width: 44px;
		height: 44px;
		// border-radius: 50%;
		object-fit: cover;
		margin-bottom: 4px;
	}

	.nav-text {
		font-size: 13px;
		font-weight: 500;
		line-height: 18px;
		text-align: center;
		color: #333333;
	}
}
</style>
